/* JAK'S DIESEL — shared interactions */
(function(){
  // ---- Mobile nav toggle ----
  window.toggleMobileNav = function(forceOpen){
    var body = document.body;
    var drawer = document.getElementById('mnav');
    var overlay = document.querySelector('.mnav-overlay');
    var trigger = document.querySelector('.nav .hamburger');
    var wasOpen = body.classList.contains('mnav-open');
    var open = typeof forceOpen === 'boolean' ? forceOpen : !wasOpen;
    body.classList.toggle('mnav-open',open);
    if(trigger) trigger.setAttribute('aria-expanded',open?'true':'false');
    if(drawer){
      drawer.setAttribute('aria-hidden',open?'false':'true');
      if(open) drawer.removeAttribute('inert');
      else drawer.setAttribute('inert','');
    }
    if(overlay) overlay.setAttribute('aria-hidden',open?'false':'true');
    if(open){
      var closeButton = drawer && drawer.querySelector('.mnav-close');
      if(closeButton) window.setTimeout(function(){ closeButton.focus(); },0);
    } else if(wasOpen && trigger){
      trigger.focus();
    }
  };

  // ---- Live search autocomplete (Shopify predictive search) ----
  function acEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function predictiveUrl(predictiveQuery){
    return '/search/suggest.json?q=' + encodeURIComponent(predictiveQuery) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,tag,body';
  }
  function findPrefixedPartSuggestion(query, types, requestOptions){
    // Offer a separate search, never an inferred interchange or automatic redirect.
    // Keep all ten digits, including leading zeros; do not rewrite other formats.
    if(!/^\d{10}$/.test(query)) return Promise.resolve(null);
    var candidate = 'A' + query;
    var queries = types.length ? types.map(function(type){ return type + ' ' + candidate; }) : [candidate];
    var exactNumber = new RegExp('(^|[^A-Z0-9_/-])' + candidate + '($|[^A-Z0-9_/-])', 'i');
    return Promise.all(queries.map(function(q){
      return fetch(predictiveUrl(q), requestOptions)
        .then(function(response){ return response.ok ? response.json() : null; });
    })).then(function(responses){
      var found = responses.some(function(data){
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        return products.some(function(product){
          if(types.length && types.indexOf(product.product_type || product.type || '') === -1) return false;
          var text = [product.title, product.body, product.sku].concat(product.tags || []).join(' ').replace(/<[^>]*>/g, ' ');
          return exactNumber.test(text);
        });
      });
      return found ? candidate : null;
    }).catch(function(){ return null; });
  }
  function bindEmptySearchSuggestions(){
    document.querySelectorAll('[data-jaks-part-suggestion]').forEach(function(container){
      if(container.dataset.suggestionBound) return;
      container.dataset.suggestionBound = '1';
      var params = new URLSearchParams(window.location.search);
      // Predictive results expose product type but cannot verify other active facets.
      var unsupportedFilter = false;
      params.forEach(function(value, key){
        if(key.indexOf('filter.') === 0 && key !== 'filter.p.product_type') unsupportedFilter = true;
      });
      if(unsupportedFilter) return;
      var types = params.getAll('filter.p.product_type');
      findPrefixedPartSuggestion(container.dataset.searchQuery, types, {}).then(function(candidate){
        if(!candidate) return;
        var link = container.querySelector('a');
        if(!link) return;
        params.set('q', candidate);
        params.set('type', 'product');
        params.delete('page');
        link.setAttribute('href', container.dataset.searchUrl + '?' + params.toString());
        link.textContent = container.dataset.suggestionLabel.replace('__NUMBER__', candidate);
        container.hidden = false;
      });
    });
  }
  window.bindSearch = function(inputRef, panelRef){
    var input = typeof inputRef === 'string' ? document.getElementById(inputRef) : inputRef;
    var panel = typeof panelRef === 'string' ? document.getElementById(panelRef) : panelRef;
    if(!input || !panel || input.dataset.acBound) return;
    input.dataset.acBound = '1';
    var timer;
    var activeSearchController = null;
    var searchRequestId = 0;
    var form = input.closest('form');
    var category = form && form.querySelector('[data-jaks-product-types]');
    function selectedTypes(){
      if(!category || !category.value) return [];
      return category.value.split(',').map(function(value){ return value.trim(); }).filter(Boolean);
    }
    function typeParams(types){
      return types.map(function(value){ return '&filter.p.product_type=' + encodeURIComponent(value); }).join('');
    }
    function cancelPendingSearch(){
      searchRequestId += 1;
      if(activeSearchController){
        activeSearchController.abort();
        activeSearchController = null;
      }
    }
    function setOpen(open){ panel.classList.toggle('open', open); input.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    function close(){ cancelPendingSearch(); setOpen(false); }
    function render(q){
      q = (q || '').trim();
      if(q.length < 2){ close(); return; }
      var types = selectedTypes();
      var typeParameters = typeParams(types);
      var all = '<a class="ac-row ac-all" role="option" href="/search?q=' + encodeURIComponent(q) + '&type=product' + typeParameters + '"><div class="ac-main"><div class="t" style="color:var(--mil)">See all results for &ldquo;' + acEsc(q) + '&rdquo; &rarr;</div></div></a>';
      cancelPendingSearch();
      var requestId = searchRequestId;
      activeSearchController = typeof AbortController === 'function' ? new AbortController() : null;
      var requestOptions = activeSearchController ? { signal: activeSearchController.signal } : {};
      var predictiveQueries = types.length ? types.map(function(productType){ return productType + ' ' + q; }) : [q];

      Promise.all(predictiveQueries.map(function(predictiveQuery){
        return fetch(predictiveUrl(predictiveQuery), requestOptions)
          .then(function(response){ return response.ok ? response.json() : null; });
      }))
        .then(function(responses){
          if(requestId !== searchRequestId) return;
          var ps = [];
          var seen = {};
          responses.forEach(function(data){
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            products.forEach(function(p){
              var productType = p.product_type || p.type || '';
              if(types.length && types.indexOf(productType) === -1) return;
              var key = p.id || p.url || p.handle;
              if(key && seen[key]) return;
              if(key) seen[key] = true;
              if(ps.length < 10) ps.push(p);
            });
          });
          if(!ps.length){
            panel.innerHTML = '<div class="ac-group"><div class="ac-row"><div class="ac-main"><div class="t">No instant match — our specialists cross it for you.</div><div class="s">Call or text (720) 445-6249</div></div></div>' + all + '</div>';
            findPrefixedPartSuggestion(q, types, requestOptions).then(function(candidate){
              if(!candidate || requestId !== searchRequestId) return;
              var url = '/search?q=' + encodeURIComponent(candidate) + '&type=product' + typeParameters;
              panel.innerHTML = '<div class="ac-group"><a class="ac-row" role="option" href="' + acEsc(url) + '"><div class="ac-main"><div class="t">Did you mean ' + acEsc(candidate) + '?</div><div class="s">Search this part number</div></div></a>' + all + '</div>';
            });
          } else {
            panel.innerHTML = '<div class="ac-group"><div class="ac-label">Matching Parts</div>' + ps.map(function(p){
              var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              var thumb = img ? '<div class="ac-thumb"><img src="' + acEsc(img) + '" alt="" width="42" height="42" loading="lazy"></div>' : '<div class="ac-thumb" aria-hidden="true"></div>';
              var productType = p.product_type || p.type || '';
              var sub = productType ? '<div class="s">' + acEsc(productType) + '</div>' : '';
              var title = (p.title || '').split('|')[0].trim();
              return '<a class="ac-row" role="option" href="' + acEsc(p.url) + '">' + thumb + '<div class="ac-main"><div class="t">' + acEsc(title) + '</div>' + sub + '</div></a>';
            }).join('') + all + '</div>';
          }
          setOpen(true);
        })
        .catch(function(error){
          if(requestId !== searchRequestId || (error && error.name === 'AbortError')) return;
          close();
        });
    }
    input.addEventListener('input', function(e){ clearTimeout(timer); timer = setTimeout(function(){ render(e.target.value); }, 180); });
    input.addEventListener('focus', function(e){ if((e.target.value || '').trim().length >= 2) render(e.target.value); });
    input.addEventListener('keydown', function(e){
      if(e.key === 'Escape') close();
      if(e.key === 'ArrowDown' && panel.classList.contains('open')){
        var first = panel.querySelector('a');
        if(first){ e.preventDefault(); first.focus(); }
      }
    });
    panel.addEventListener('keydown', function(e){
      var links = Array.prototype.slice.call(panel.querySelectorAll('a'));
      var index = links.indexOf(document.activeElement);
      if(e.key === 'Escape'){ close(); input.focus(); }
      else if(e.key === 'ArrowDown' && links.length){ e.preventDefault(); links[(index + 1) % links.length].focus(); }
      else if(e.key === 'ArrowUp' && links.length){ e.preventDefault(); links[(index - 1 + links.length) % links.length].focus(); }
    });
    if(category) category.addEventListener('change', function(){ if(input.value.trim().length >= 2) render(input.value); });
    if(form && category){
      form.addEventListener('submit',function(){
        Array.prototype.slice.call(form.querySelectorAll('[data-jaks-generated-type]')).forEach(function(field){ field.remove(); });
        selectedTypes().forEach(function(productType){
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'filter.p.product_type';
          hidden.value = productType;
          hidden.dataset.jaksGeneratedType = 'true';
          form.appendChild(hidden);
        });
      });
    }
    document.addEventListener('click', function(e){ if(!panel.contains(e.target) && e.target !== input) close(); });
  };
  // Auto-wire every search box that has an .ac results panel (header, hero, 404)
  function autoBindSearch(){
    bindEmptySearchSuggestions();
    document.querySelectorAll('.ac').forEach(function(panel){
      var c = panel.closest('.search, .hero-search, .searchbox');
      var inp = c && c.querySelector('input[type="search"], input[type="text"]');
      if(inp){ window.bindSearch(inp, panel); }
    });
  }
  if(document.readyState !== 'loading') autoBindSearch();
  else document.addEventListener('DOMContentLoaded', autoBindSearch);


  // ---- Product page quantity + accessible tabs ----
  window.qtyStep = window.jaksQty = function(delta){
    var input = document.getElementById('qty');
    if(!input) return;
    input.value = Math.max(1, (parseInt(input.value,10) || 1) + delta);
  };

  function bindTabs(){
    document.querySelectorAll('[data-jaks-tabs]').forEach(function(tabs){
      if(tabs.dataset.bound) return;
      tabs.dataset.bound = 'true';
      var triggers = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function activate(trigger,focus){
        triggers.forEach(function(item){
          var selected = item === trigger;
          item.classList.toggle('active',selected);
          item.setAttribute('aria-selected',selected?'true':'false');
          item.setAttribute('tabindex',selected?'0':'-1');
          var panel = document.getElementById(item.getAttribute('aria-controls'));
          if(panel){ panel.hidden = !selected; panel.classList.toggle('active',selected); }
        });
        if(focus) trigger.focus();
      }
      triggers.forEach(function(trigger,index){
        trigger.addEventListener('click',function(){activate(trigger,false);});
        trigger.addEventListener('keydown',function(event){
          var next = index;
          if(event.key === 'ArrowRight') next = (index + 1) % triggers.length;
          else if(event.key === 'ArrowLeft') next = (index - 1 + triggers.length) % triggers.length;
          else if(event.key === 'Home') next = 0;
          else if(event.key === 'End') next = triggers.length - 1;
          else return;
          event.preventDefault();
          activate(triggers[next],true);
        });
      });
    });
  }

  window.showTab = function(id,trigger){
    var target = document.getElementById(id);
    if(target && trigger) trigger.click();
  };

  // ---- Mobile collection filter drawer ----
  function bindCollectionFilters(){
    var toggle = document.querySelector('[data-filter-toggle]');
    var panel = document.getElementById('collectionFilters');
    if(!toggle || !panel) return;
    var overlay = document.querySelector('.filter-overlay');
    function setOpen(open){
      panel.classList.toggle('is-open',open);
      document.body.classList.toggle('filters-open',open);
      toggle.setAttribute('aria-expanded',open?'true':'false');
      if(overlay) overlay.hidden = !open;
      if(open) panel.focus();
      else toggle.focus();
    }
    toggle.addEventListener('click',function(){setOpen(true);});
    document.querySelectorAll('[data-filter-close]').forEach(function(control){
      control.addEventListener('click',function(){setOpen(false);});
    });
    document.addEventListener('keydown',function(event){
      if(event.key === 'Escape' && panel.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('resize',function(){
      if(window.innerWidth > 760 && panel.classList.contains('is-open')) setOpen(false);
    });
  }

  // ---- Shopify product recommendations ----
  function bindRelatedProducts(){
    document.querySelectorAll('[data-related-section][data-related-loaded="false"]').forEach(function(section){
      var url = section.dataset.recommendationsUrl;
      if(!url || section.dataset.loading) return;
      section.dataset.loading = 'true';
      fetch(url).then(function(response){
        if(!response.ok) throw new Error('recommendations');
        return response.text();
      }).then(function(html){
        var parsed = new DOMParser().parseFromString(html,'text/html');
        var replacement = parsed.querySelector('[data-related-section]');
        var grid = replacement && replacement.querySelector('[data-related-grid]');
        if(replacement && grid && grid.children.length) section.replaceWith(replacement);
        else section.remove();
      }).catch(function(){ section.remove(); });
    });
  }

  function bindUsedInKits(){
    document.querySelectorAll('[data-used-in-kits]').forEach(function(section){
      if(section.dataset.usedInKitsBound) return;
      section.dataset.usedInKitsBound = 'true';
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-used-in-kits-row]'));
      var filter = section.querySelector('[data-used-in-kits-filter]');
      var more = section.querySelector('[data-used-in-kits-more]');
      var empty = section.querySelector('[data-used-in-kits-empty]');
      var visibleLimit = parseInt(section.dataset.usedInKitsVisible,10) || 20;
      var expanded = false;

      function applyUsedInKits(){
        var query = (filter && filter.value || '').trim().toLowerCase();
        var matches = 0;
        rows.forEach(function(row){
          var rowIndex = parseInt(row.dataset.usedInKitsIndex,10) || 0;
          var filterValue = row.dataset.filterValue || '';
          var matchesQuery = !query || filterValue.indexOf(query) > -1;
          row.hidden = query ? !matchesQuery : (rowIndex > visibleLimit && !expanded);
          if(matchesQuery) matches += 1;
        });
        if(empty) empty.hidden = matches > 0;
        if(more){
          more.hidden = Boolean(query) || expanded;
          more.setAttribute('aria-expanded',expanded ? 'true' : 'false');
        }
      }

      if(filter) filter.addEventListener('input',applyUsedInKits);
      if(more) more.addEventListener('click',function(){
        expanded = true;
        applyUsedInKits();
      });
      applyUsedInKits();
    });
  }

  function bindKitContents(){
    document.querySelectorAll('[data-kit-contents]').forEach(function(section){
      if(section.dataset.kitContentsBound) return;
      section.dataset.kitContentsBound = 'true';
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-kit-contents-row]'));
      var filter = section.querySelector('[data-kit-contents-filter]');
      var more = section.querySelector('[data-kit-contents-more]');
      var empty = section.querySelector('[data-kit-contents-empty]');
      var expanded = false;

      function applyKitContents(){
        var query = (filter && filter.value || '').trim().toLowerCase();
        var matches = 0;
        rows.forEach(function(row){
          var rowIndex = parseInt(row.dataset.kitContentsIndex,10) || 0;
          var matchesQuery = !query || (row.dataset.filterValue || '').indexOf(query) > -1;
          row.hidden = query ? !matchesQuery : (rowIndex > 10 && !expanded);
          if(matchesQuery) matches += 1;
        });
        if(empty) empty.hidden = matches > 0;
        if(more){
          more.hidden = Boolean(query) || expanded;
          more.setAttribute('aria-expanded',expanded ? 'true' : 'false');
        }
      }

      if(filter) filter.addEventListener('input',applyKitContents);
      if(more) more.addEventListener('click',function(){
        expanded = true;
        applyKitContents();
      });
      applyKitContents();
    });
  }

  function bindXrefTables(){
    document.querySelectorAll('[data-xref-table]').forEach(function(section){
      if(section.dataset.xrefBound) return;
      section.dataset.xrefBound = 'true';
      var panel = section.closest('[role="tabpanel"]') || section.parentNode;
      var rows = Array.prototype.slice.call(section.querySelectorAll('[data-xref-row]'));
      var filter = panel && panel.querySelector('[data-xref-filter]');
      var more = section.querySelector('[data-xref-more]');
      var empty = section.querySelector('[data-xref-empty]');
      var expanded = false;

      function applyXrefs(){
        var query = (filter && filter.value || '').trim().toLowerCase();
        var matches = 0;
        rows.forEach(function(row){
          var rowIndex = parseInt(row.dataset.xrefIndex,10) || 0;
          var matchesQuery = !query || (row.dataset.filterValue || '').indexOf(query) > -1;
          row.hidden = query ? !matchesQuery : (rowIndex > 10 && !expanded);
          if(matchesQuery) matches += 1;
        });
        if(empty) empty.hidden = matches > 0;
        if(more){
          more.hidden = Boolean(query);
          more.textContent = expanded ? more.dataset.hideLabel : more.dataset.showLabel;
          more.setAttribute('aria-expanded',expanded ? 'true' : 'false');
        }
      }

      if(filter) filter.addEventListener('input',applyXrefs);
      if(more) more.addEventListener('click',function(){
        expanded = !expanded;
        applyXrefs();
      });
      applyXrefs();
    });
  }

  // ---- Mobile/tablet purchase bar: show only while the main purchase action is off-screen ----
  function bindMobilePurchaseBar(){
    var bar = document.querySelector('[data-mobile-purchase-bar]');
    var target = document.querySelector('[data-main-purchase-actions]');
    if(!bar || !target || bar.dataset.purchaseBarBound) return;
    bar.dataset.purchaseBarBound = 'true';
    var media = window.matchMedia('(max-width: 1024px)');
    var observer = null;

    function setVisible(visible){
      visible = Boolean(visible && media.matches);
      bar.classList.toggle('is-visible',visible);
      bar.setAttribute('aria-hidden',visible ? 'false' : 'true');
    }

    function fallbackUpdate(){
      var rect = target.getBoundingClientRect();
      setVisible(rect.bottom <= 0 || rect.top >= window.innerHeight);
    }

    function bindObserver(){
      if(observer){
        observer.disconnect();
        observer = null;
      }
      if(!media.matches){
        setVisible(false);
        return;
      }
      if('IntersectionObserver' in window){
        observer = new IntersectionObserver(function(entries){
          setVisible(entries[0].intersectionRatio < 0.6);
        },{threshold:[0,0.6]});
        observer.observe(target);
      } else {
        fallbackUpdate();
      }
    }

    if(media.addEventListener) media.addEventListener('change',bindObserver);
    else media.addListener(bindObserver);
    if(!('IntersectionObserver' in window)){
      window.addEventListener('scroll',fallbackUpdate,{passive:true});
      window.addEventListener('resize',fallbackUpdate);
    }
    bindObserver();
  }

  // ---- Accessible custom select enhancement ----
  function place(panel,trigger){
    var rect = trigger.getBoundingClientRect();
    var width = Math.max(rect.width,200);
    panel.style.minWidth = width + 'px';
    panel.style.left = Math.max(8,Math.min(rect.left,window.innerWidth-width-8)) + 'px';
    panel.style.top = (rect.bottom + 6) + 'px';
  }
  function closeAll(except){
    document.querySelectorAll('.cs-panel.open').forEach(function(panel){
      if(panel !== except){ panel.classList.remove('open'); panel.hidden = true; }
    });
    document.querySelectorAll('.cselect.open').forEach(function(wrapper){
      if(!except || wrapper.dataset.panel !== except.id){
        wrapper.classList.remove('open');
        var trigger = wrapper.querySelector('.cs-trigger');
        if(trigger) trigger.setAttribute('aria-expanded','false');
      }
    });
  }
  function enhanceSelects(){
    document.querySelectorAll('select.js-cselect').forEach(function(select,index){
      if(select.dataset.enhanced) return;
      select.dataset.enhanced = 'true';
      var wrapper = document.createElement('div');
      var trigger = document.createElement('button');
      var label = document.createElement('span');
      var panel = document.createElement('div');
      var panelId = 'jaks-select-' + index + '-' + Math.random().toString(36).slice(2,7);
      var accessibleName = select.getAttribute('aria-label') || (select.labels && select.labels[0] ? select.labels[0].textContent.trim() : 'Choose option');
      wrapper.className = 'cselect';
      wrapper.dataset.panel = panelId;
      trigger.type = 'button';
      trigger.className = 'cs-trigger';
      trigger.setAttribute('aria-haspopup','listbox');
      trigger.setAttribute('aria-expanded','false');
      trigger.setAttribute('aria-controls',panelId);
      trigger.setAttribute('aria-label',accessibleName);
      label.className = 'cs-label';
      panel.id = panelId;
      panel.className = 'cs-panel';
      panel.setAttribute('role','listbox');
      panel.setAttribute('aria-label',accessibleName);
      panel.hidden = true;
      trigger.appendChild(label);
      trigger.insertAdjacentHTML('beforeend','<span class="cs-caret" aria-hidden="true"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M6 9l6 6 6-6"/></svg></span>');

      function rows(){ return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]:not([disabled])')); }
      function choose(row,optionIndex){
        if(select.options[optionIndex].disabled) return;
        select.selectedIndex = optionIndex;
        label.textContent = select.options[optionIndex].textContent;
        rows().forEach(function(item){
          var selected = item === row;
          item.classList.toggle('sel',selected);
          item.setAttribute('aria-selected',selected?'true':'false');
        });
        closeAll();
        trigger.focus();
        select.dispatchEvent(new Event('change',{bubbles:true}));
      }

      Array.prototype.slice.call(select.options).forEach(function(option,optionIndex){
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'cs-opt' + (option.selected?' sel':'');
        row.setAttribute('role','option');
        row.setAttribute('aria-selected',option.selected?'true':'false');
        row.disabled = option.disabled;
        row.setAttribute('aria-disabled',option.disabled?'true':'false');
        row.innerHTML = '<span>'+acEsc(option.textContent)+'</span><span class="ck" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg></span>';
        row.addEventListener('click',function(){choose(row,optionIndex);});
        row.addEventListener('keydown',function(event){
          var options = rows();
          var current = options.indexOf(row);
          if(event.key === 'ArrowDown'){event.preventDefault();options[(current+1)%options.length].focus();}
          else if(event.key === 'ArrowUp'){event.preventDefault();options[(current-1+options.length)%options.length].focus();}
          else if(event.key === 'Home'){event.preventDefault();options[0].focus();}
          else if(event.key === 'End'){event.preventDefault();options[options.length-1].focus();}
          else if(event.key === 'Enter' || event.key === ' '){event.preventDefault();choose(row,optionIndex);}
          else if(event.key === 'Escape'){closeAll();trigger.focus();}
        });
        panel.appendChild(row);
      });

      label.textContent = select.options[select.selectedIndex] ? select.options[select.selectedIndex].textContent : '';
      trigger.addEventListener('click',function(event){
        event.stopPropagation();
        var open = wrapper.classList.contains('open');
        closeAll();
        if(!open){
          wrapper.classList.add('open');
          panel.classList.add('open');
          panel.hidden = false;
          trigger.setAttribute('aria-expanded','true');
          place(panel,trigger);
        }
      });
      trigger.addEventListener('keydown',function(event){
        if(event.key === 'ArrowDown' || event.key === 'ArrowUp'){
          event.preventDefault();
          if(!wrapper.classList.contains('open')) trigger.click();
          var options = rows();
          if(options.length) (event.key === 'ArrowDown' ? options[0] : options[options.length-1]).focus();
        } else if(event.key === 'Escape') closeAll();
      });
      wrapper.appendChild(trigger);
      document.body.appendChild(panel);
      select.hidden = true;
      select.setAttribute('aria-hidden','true');
      select.tabIndex = -1;
      select.parentNode.insertBefore(wrapper,select);
    });
  }
  window.enhanceSelects = enhanceSelects;

  function initialize(){
    bindTabs();
    bindCollectionFilters();
    bindRelatedProducts();
    bindKitContents();
    bindUsedInKits();
    bindXrefTables();
    bindMobilePurchaseBar();
    enhanceSelects();
    document.addEventListener('click',function(){closeAll();});
    window.addEventListener('resize',function(){closeAll();});
    window.addEventListener('scroll',function(){closeAll();},true);
    document.addEventListener('shopify:section:load',function(){
      bindKitContents();
      bindUsedInKits();
      bindXrefTables();
    });
  }
  if(document.readyState !== 'loading') initialize();
  else document.addEventListener('DOMContentLoaded',initialize);
})();
